import ApiDocs from "../../../../src/pages/api-docs";
import * as React from 'react';
export default {
  ApiDocs,
  React
};